import { css } from '@emotion/react';
import { tokens, Link } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

import { Icon } from '@hotjar/webapp/components/Icon';

interface ThumbsUpDownFooterProps {
  text: string;
  href: string;
  className?: string;
}

export const ThumbsUpDownFooter = ({
  text,
  href,
  className,
}: ThumbsUpDownFooterProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <Icon
        size={10}
        icon="info"
        color={tokens.color.text_light_inverse}
        css={css`
          padding-right: 2px;
        `}
      />{' '}
      {text}&nbsp;
      <Link
        kind="inline"
        href={href}
        isExternal
        css={css`
          color: ${tokens.color.text_light_inverse};
          &:hover,
          &:active,
          &:focus {
            color: ${tokens.color.text_light_inverse};
          }
        `}
      >
        {t('common:player.thumbs-up-down.footer.link')}
      </Link>
    </div>
  );
};
